import React from "react";
import { useIntl } from "react-intl";

import { RichText } from "@learningblocks/shared-components/lib/RichText";

import { TableCellProps, CellAlignment } from "../types";
import { titleCellClass } from "../TableQuestion.css";

export interface TitleCellProps extends Pick<
  TableCellProps,
  "cellId" | "text" | "colspan" | "ariaLabel"
> {
  bgColor?: string;
  align?: CellAlignment;
  /**
   * Header scope. Top header cells are "col"; first-column row labels are "row"
   * so a screen reader announces only that cell's label, not the whole column.
   */
  scope?: "col" | "row";
}

export const TitleCell: React.FC<TitleCellProps> = ({
  cellId,
  text,
  colspan,
  bgColor,
  align,
  scope = "col",
  ariaLabel,
}) => {
  const intl = useIntl();

  const translatedText = text
    ? intl.formatMessage({ id: text, defaultMessage: text })
    : "";

  const translatedAriaLabel = ariaLabel
    ? intl.formatMessage({ id: ariaLabel, defaultMessage: ariaLabel })
    : undefined;

  const style: React.CSSProperties = {
    ...(bgColor && { backgroundColor: bgColor }),
    ...(align && { textAlign: align }),
  };

  return (
    <th
      key={cellId}
      className={titleCellClass}
      colSpan={colspan ? Number(colspan) : undefined}
      scope={scope}
      style={style}
      aria-label={translatedAriaLabel}
    >
      <RichText value={translatedText} />
    </th>
  );
};
